import { memo } from 'react';
import { matchRoutes, useLocation } from 'react-router';
import { selectIsLogged } from '@bonanza-social/auth/state';
import { useSelector } from '@bonanza-social/toolkit/state';

import MainHeader from './MainHeader/MainHeader';
import RouteHeader from './RouteHeader/RouteHeader';
import {
  MainHeaderDisabledRoutes,
  RouteHeaderDisabledRoutes,
} from './Header.constants';
import styles from './Header.module.css';
import AuthHeader from './AuthHeader/AuthHeader';

function Header() {
  const location = useLocation();
  const isLoggedIn = useSelector(selectIsLogged);
  const mainHeaderDisabled = matchRoutes(MainHeaderDisabledRoutes, location);
  const routeHeaderDisabled = matchRoutes(RouteHeaderDisabledRoutes, location);

  const renderHeader = () => {
    if (!isLoggedIn) {
      return <AuthHeader />;
    }

    return <MainHeader />;
  };

  if (mainHeaderDisabled && routeHeaderDisabled) {
    return null;
  }

  return (
    <header className={styles.header}>
      {mainHeaderDisabled ? null : renderHeader()}
      {routeHeaderDisabled ? null : <RouteHeader />}
    </header>
  );
}

export default memo(Header);
